{
  "generatedBy": "tools/quayGoods/quay_goods.py from tools/quayGoods/sources/woodcut_readings*.json and picture_scale.json",
  "pictureScale": 0.1288,
  "scales": {
    "quay-oudezijds-voorburgwal": 0.297,
    "quay-ij": 0.438
  },
  "bandScales": {
    "quay-oudezijds-voorburgwal": 0.4,
    "quay-ij": 0.984
  },
  "items": [
    {
      "id": "q01",
      "kind": "plankPile",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        258.25,
        -61.45
      ],
      "across": 0.335,
      "width": 1.86,
      "length": 1.29,
      "height": 0.19,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "q02",
      "kind": "boxStack",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        269.8,
        -49.79
      ],
      "across": 0.173,
      "width": 1.15,
      "length": 1.39,
      "height": 1.61,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "q03",
      "kind": "plankPile",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        272.49,
        -44.41
      ],
      "across": 0.271,
      "width": 1.8,
      "length": 1.2,
      "height": 0.19,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "q04",
      "kind": "plankFrame",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        283.33,
        -31.46
      ],
      "across": 0.318,
      "width": 1.88,
      "length": 2.39,
      "height": 0.13,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ],
      "bar": 0.26
    },
    {
      "id": "q05",
      "kind": "plankPile",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        294.55,
        -17.88
      ],
      "across": 0.38,
      "width": 2.4,
      "length": 1.54,
      "height": 0.19,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "q06",
      "kind": "boxStack",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        304.33,
        -5.06
      ],
      "across": 0.341,
      "width": 1.47,
      "length": 1.82,
      "height": 1.55,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "q07",
      "kind": "trestle",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        314.08,
        9.59
      ],
      "across": 0.434,
      "width": 2.92,
      "length": 0.18,
      "height": 3.87,
      "beam": 1.39,
      "fork": 0.516,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "q08",
      "kind": "boxStack",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        326.29,
        20.11
      ],
      "across": 0.211,
      "width": 1.09,
      "length": 1.39,
      "height": 1.48,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "q09",
      "kind": "trestle",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        330.49,
        30.27
      ],
      "across": 0.392,
      "width": 2.43,
      "length": 0.18,
      "height": 4.6,
      "beam": 1.6,
      "fork": 0.245,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "q10",
      "kind": "trestle",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        337.69,
        34.79
      ],
      "across": 0.181,
      "width": 1.3,
      "length": 0.18,
      "height": 3.47,
      "beam": 1.28,
      "fork": 1.0,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "q11",
      "kind": "plankPile",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        343.35,
        42.37
      ],
      "across": 0.295,
      "width": 2.4,
      "length": 1.73,
      "height": 0.19,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "q12",
      "kind": "trestle",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        352.62,
        58.37
      ],
      "across": 0.397,
      "width": 3.16,
      "length": 0.18,
      "height": 4.03,
      "beam": 1.04,
      "fork": 0.672,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "q13",
      "kind": "boxStack",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        364.31,
        68.27
      ],
      "across": 0.03,
      "width": 1.47,
      "length": 1.27,
      "height": 2.0,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "q14",
      "kind": "plankPile",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        365.58,
        71.66
      ],
      "across": 0.088,
      "width": 2.13,
      "length": 1.56,
      "height": 0.19,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "q15",
      "kind": "plankPile",
      "street": "quay-oudezijds-voorburgwal",
      "at": [
        371.26,
        77.02
      ],
      "across": -0.085,
      "width": 1.87,
      "length": 1.24,
      "height": 0.19,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "e1",
      "kind": "crate",
      "street": "quay-oudezijds-voorburgwal-2",
      "at": [
        390.14,
        64.17
      ],
      "across": 0.0,
      "width": 1.54,
      "length": 1.07,
      "height": 0.64,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "e2",
      "kind": "crate",
      "street": "quay-oudezijds-voorburgwal-2",
      "at": [
        399.05,
        76.39
      ],
      "across": 0.0,
      "width": 1.33,
      "length": 1.55,
      "height": 0.52,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "ij01",
      "kind": "boxStack",
      "street": "quay-ij",
      "at": [
        528.6,
        365.05
      ],
      "across": 0.522,
      "width": 2.16,
      "length": 1.62,
      "height": 1.95,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "ij02",
      "kind": "plankPile",
      "street": "quay-ij",
      "at": [
        532.05,
        368.35
      ],
      "across": 0.153,
      "width": 5.45,
      "length": 2.54,
      "height": 0.39,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "ij03",
      "kind": "boxStack",
      "street": "quay-ij",
      "at": [
        547.86,
        373.13
      ],
      "across": 0.429,
      "width": 2.48,
      "length": 1.5,
      "height": 2.83,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "ij05",
      "kind": "plankPile",
      "street": "quay-ij",
      "at": [
        562.28,
        381.92
      ],
      "across": 0.174,
      "width": 5.1,
      "length": 2.74,
      "height": 0.26,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "ij06",
      "kind": "boxStack",
      "street": "quay-ij",
      "at": [
        582.56,
        389.13
      ],
      "across": 0.421,
      "width": 2.15,
      "length": 1.48,
      "height": 2.22,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "ij09",
      "kind": "plankPile",
      "street": "quay-ij",
      "at": [
        596.62,
        397.1
      ],
      "across": 0.35,
      "width": 5.43,
      "length": 2.07,
      "height": 0.26,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    },
    {
      "id": "ij10",
      "kind": "boxStack",
      "street": "quay-ij",
      "at": [
        613.73,
        400.94
      ],
      "across": 0.668,
      "width": 1.71,
      "length": 1.46,
      "height": 1.46,
      "sourceRefs": [
        "woodcut-1544",
        "breen-keur-1501"
      ]
    }
  ]
}
